/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import _ from 'lodash';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import defaultStyles, { themeStyles } from './header.styles';
import Header, { HeaderProps } from './Header';

export interface WidgetProperties extends commonTypes.WidgetPropertiesBase, HeaderProps {}
interface WidgetProps extends commonTypes.WidgetInstanceProps, HeaderProps {
    properties?: any;
}

const HeaderWrapper = (props: WidgetProps): JSX.Element => {
    const widgetProperties =
        commonHooks.useWidgetProperties<WidgetProperties>(props.widgetInstanceId) ||
        props?.properties;
    const { disableTabStaticData: globalDisableTabStaticData } =
        commonHooks.useWidgetProperties<WidgetProperties>('root') || {};
    const { styles, headings, disableTabStaticData } = widgetProperties || props;

    const i18n = commonHooks.useLocalization();

    const { data } = props;
    const theme = data?.themeSelected || props?.theme;
    const annotator = commonHooks.useAnnotator();

    return (
        <div
            css={css`
                ${!theme ? defaultStyles : themeStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
            className={`headings ${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
        >
            {Array.isArray(headings) &&
                headings.map((h: any, i: number) => {
                    const _headerText = i18n.format(h.headerText || '', data);

                    let markers: any = '';

                    try {
                        markers =
                            !_.isEmpty(annotator) &&
                            _headerText &&
                            annotator?.markersByMarkerTargetId(`${h?.markerLabel}`);
                    } catch (e) {
                        console.log(e);
                    }

                    const boundHeaderText = i18n.format(h.headerText || '', {
                        ...data,
                        _markers: markers,
                    });
                    return (
                        <Header
                            key={i}
                            headingNumber={i}
                            headerText={boundHeaderText || ''}
                            headingLevel={h.headingLevel}
                            disableTabStaticData={
                                globalDisableTabStaticData ||
                                disableTabStaticData ||
                                h.disableHeadingTabStaticData
                            }
                        />
                    );
                })}
        </div>
    );
};

export default HeaderWrapper;
